import React from 'react';
import styled from 'styled-components';
import { theme } from '../../styles/GlobalStyles';

const SectionContainer = styled.section`
  padding: 5rem 0;
  background-color: ${props => props.bgColor || theme.bg};
  position: relative;
`;

const SectionContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
`;

const ContentSection = ({ children, bgColor, id }) => (
  <SectionContainer bgColor={bgColor} id={id}>
    <SectionContent>{children}</SectionContent>
  </SectionContainer>
);

export default ContentSection;
